import 'react-dates/initialize';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getUserSession,
  logout,
  impersonate,
  impersonateOCM,
} from 'actions/authentication';
import PageFooter from 'components/Credit24/Core/PageFooter';
import SideNavigation from 'components/Credit24/SelfService/Navigation/SideNavigation';
import LogoutButton from 'components/Credit24/SelfService/Navigation/LogoutButton';
import { getRootURL, logoutAndImpersonate } from 'utils/helpers';
import getCookiesManager from 'utils/cookiesManager';
import { navigationItemsAU, navigationItemsAUIL, navigationItemsFI } from 'consts/selfservice/navigationItems';
import LiveagentButton from 'components/Credit24/Core/LiveagentButton';
import injectTranslations from 'utils/injectTranslations';

const propTypes = {
  children: PropTypes.object,
  getUserSession: PropTypes.func,
  logout: PropTypes.func,
  authentication: PropTypes.object,
  selfservice: PropTypes.object,
  router: PropTypes.object,
  location: PropTypes.object,
  intl: PropTypes.object.isRequired,
  impersonate: PropTypes.func.isRequired,
  impersonateOCM: PropTypes.func.isRequired,
};

class Application extends Component {
  UNSAFE_componentWillMount() {
    const {
      logout: _logout,
      impersonateOCM: _impersonateOCM,
      impersonate: _impersonate,
      getUserSession: _getUserSession,
    } = this.props;

    logoutAndImpersonate(_logout, _impersonateOCM, _impersonate, _getUserSession);
  }

  componentDidMount() {
    if (COUNTRY === 'AU') {
      if (window.location.hash === '#legacy-login-redirect' && getCookiesManager()) {
        getCookiesManager().saveValue('CL TARGET', 'customer-segment', false, 365, '.credit24.com.au');
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { authentication, router } = this.props;

    if (authentication.isChangingPassword && !nextProps.authentication.isChangingPassword) {
      const { location, replace } = router;
      const { from } = location.state || { from: { pathname: '/' } };
      replace(from);
    }

    if (
      nextProps.selfservice.waitingForNewContract
      && authentication.contracts[0] !== nextProps.authentication.contracts[0]
    ) {
      router.replace({ pathname: '/dashboard' });
    }

    if (this.props.location.pathname !== nextProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children, ...rest } = this.props;
    const { selfservice, authentication } = this.props;
    const { creditApplicationState } = selfservice;
    const { identifier, firstName, lastName } = authentication;
    const { intl } = this.props;
    const showChat = COUNTRY === 'FI' && !!identifier;

    const contractId = authentication.contracts && authentication.contracts[0];
    const contract = selfservice.contracts[contractId];
    let isProductLoadedAU = true;
    if (COUNTRY === 'AU') {
      isProductLoadedAU = !!(contract && contract.product);
    }

    let navigationItems;

    if (COUNTRY === 'FI') {
      navigationItems = navigationItemsFI;
    }
    if (COUNTRY === 'AU') {
      navigationItems = navigationItemsAU;

      if (contract && contract.product && contract.product.type === 'INSTALLMENT') {
        navigationItems = navigationItemsAUIL;
      }
    }

    const nav = (
      <span className="page-header__nav page-header__nav--portable pull-right">
        <SideNavigation
          {...rest}
          navigationItems={navigationItems}
          showContent={isProductLoadedAU}
        />
      </span>
    );
    const logoutButton = (
      <span className="page-header__nav page-header__nav--desktop pull-right">
        <LogoutButton {...rest} />
      </span>
    );

    return (
      <div className="page-container">
        <div className="page-wrapper">
          <header className="page-header">
            <div className="container clearfix">
              <a
                href={getRootURL(intl.locale)}
                className="page-header__logo hide-text"
              >
                Credit 24
              </a>
              {COUNTRY === 'FI' && !creditApplicationState && (
                <>
                  {nav}
                  {logoutButton}
                </>
              )}
              {COUNTRY === 'AU' && (
                <>
                  {!creditApplicationState && nav}
                  {(!creditApplicationState || creditApplicationState === 'ABANDONED') && logoutButton}
                </>
              )}
            </div>
          </header>
          <div className="page-content">
            {children}
          </div>
        </div>
        <PageFooter
          intl={intl}
          showChat={showChat}
        />
        {showChat
          && <LiveagentButton identifier={identifier} firstName={firstName} lastName={lastName} />}
      </div>
    );
  }
}

Application.propTypes = propTypes;

export default injectTranslations(connect(
  (state) => ({
    authentication: state.authentication,
    selfservice: state.selfservice,
    params: state.integration,
  }),
  {
    getUserSession,
    logout,
    impersonate,
    impersonateOCM,
  }
)(injectIntl(Application)));
